import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=588dd667&scoped=true"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"
import style0 from "./Configurations.vue?vue&type=style&index=0&id=588dd667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dd667",
  null
  
)

export default component.exports